import React from 'react'

export const HomeView = () => (
  window.location.href = '/trang-chu'
)

export default HomeView



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeView.js